import React from 'react';

import { Typography } from '@telus-uds/components-web';

const Error401 = () => {
  return (
    <div style={{ margin: '1em 0', textAlign: 'center' }}>
      <Typography heading="h1" variant={{ size: 'display' }} block>401</Typography>
      <Typography heading="h1" variant={{ size: 'h1' }} block>UNAUTHORIZED</Typography>
    </div>
  );
};

export default Error401;
